import { Component, Host, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { CSOrVendorComments, defaultReview, IReview, ReviewImageType } from '@ugc-components/ugc-pdp-review/interface';
import { ReportAbuseType } from '@ugc-containers/ugc-report-abuse/interfaces';
import { isRtl } from '@ugc-utils/utils';
import { modalZIndex } from '@ugc-utils/modal-z-index';

@Component({
  tag: 'ugc-review-item-top-review',
  styleUrl: 'ugc-review-item-top-review.scss',
  shadow: false,
})
export class UgcReviewItemTopReview {
  @Prop({ mutable: true }) reviewItem: IReview = defaultReview;
  render() {
    const { isDesktop } = state;
    const {
      id,
      profileImageUrl,
      customerProfileLink,
      customerNickname,
      ratingValue,
      reviewTitle,
      reviewText,
      postedDateLocalized,
      badge,
      summary: { reviewCount, imageCount, answerCount, helpfulCount },
      verifiedPurchase,
      hasRewarded,
      hasThumbsUp,
      helpfulYes,
      helpfulNo,
      shareUrl,
      customerServiceComments,
      vendorComments,
      country,
    } = this.reviewItem;
    return (
      <Host class="ugc-review-item-top-review-wrap">
        <div class="top-review-content">
          <div class="mb-16 flex-row-start-center gap-8">
            <ugc-review-avatar size="48" profileImageUrl={profileImageUrl} customerProfileLink={customerProfileLink} />
            <div class="flex-row-between-start grow-1">
              <div class="flex-col-start-start">
                <div class="flex-row-center-center gap-8">
                  <ugc-review-nickname customerProfileLink={customerProfileLink} customerNickname={customerNickname} />
                  <ugc-review-badge badge={badge} reviewId={id} />
                </div>
                {!!country && <span class={`${isDesktop ? 'fs-14 lh-20' : 'fs-12 lh-26'}`}>{country}</span>}
                <div class="mt-4">
                  <ugc-review-profile-summary
                    reviewCount={reviewCount}
                    imageCount={imageCount}
                    answerCount={answerCount}
                    helpfulCount={helpfulCount}
                  />
                </div>
              </div>
              <ugc-review-postdate postedDateLocalized={postedDateLocalized} />
            </div>
          </div>
          <div class="mb-8 flex-row-start-center flex-wrap gap-8">
            <ugc-with-link url={shareUrl}>
              <ugc-star withTips={false} disabled={true} size={isDesktop ? 24 : 16} realValue={ratingValue} />
            </ugc-with-link>
            <ugc-review-title reviewTitle={reviewTitle} shareUrl={shareUrl} />
          </div>
          <ugc-review-labels verifiedPurchase={verifiedPurchase} hasRewarded={hasRewarded} />
          <ugc-with-link url={shareUrl}>
            <p class="my-16 fs-16 color-gray-700 break-word " innerHTML={reviewText} data-testid="pdp-review-text"></p>
          </ugc-with-link>

          <ugc-review-content-images data={this.reviewItem} type={ReviewImageType.InTopReview} />

          <div class="my-16">
            <ugc-medical-disclaimer />
          </div>
          {customerServiceComments && (
            <div class="mb-16">
              <ugc-review-comments
                type={CSOrVendorComments.CS}
                date={customerServiceComments.postedDateLocalized}
                content={customerServiceComments.content}
              />
            </div>
          )}
          {vendorComments && (
            <div class="mb-16">
              <ugc-review-comments
                type={CSOrVendorComments.Brand}
                date={vendorComments.postedDateLocalized}
                content={vendorComments.content}
              />
            </div>
          )}
        </div>
        <div class="top-review-opration flex-row-between-start py-8">
          <div class="flex-row-start-center">
            <ugc-review-vote rid={id} hasThumbsUp={hasThumbsUp} helpfulYes={helpfulYes} helpfulNo={helpfulNo} />
          </div>
          <div class="flex-row-end-end gap-8">
            <ugc-report-abuse type={ReportAbuseType.Review} referenceId={id} data-testid="pdp-review-report-abuse" />
            <ugc-share
              sid={`top-review-modal-${id}`}
              shareWidgetLayer={modalZIndex['share-widget-layer']}
              shareUrl={shareUrl}
              position={isRtl() ? 'right' : 'left'}
              gaEvent={{
                'data-ga-event-name': 'open_share_widget',
                'data-ga-content-type': 'review',
                'data-ga-location-detail': 'pdp review',
              }}
              data-testid="pdp-review-share"
            />
          </div>
        </div>
      </Host>
    );
  }
}
